module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/header_images/header-c-4d13aa15ef7a09791ed916c38624222c.svg";